import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { resolveSentryRelease } from './app/core/sentry/sentry-release';

Sentry.init({
  dsn: "https://efa2af5ac6302910d9f3813d93420537@o4509323360272384.ingest.us.sentry.io/4511446665527296",
  release: resolveSentryRelease(),
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: "system",
      isNameRequired: false,
      isEmailRequired: false,
      triggerLabel: "Reportar un error",
      triggerAriaLabel: "Reportar un error",
      formTitle: "Reportar un error",
      submitButtonLabel: "Enviar reporte",
      cancelButtonLabel: "Cancelar",
      confirmButtonLabel: "Confirmar",
      addScreenshotButtonLabel: "Agregar captura",
      removeScreenshotButtonLabel: "Quitar captura",
      nameLabel: "Nombre",
      namePlaceholder: "Tu nombre",
      emailLabel: "Correo electrónico",
      emailPlaceholder: "tu.correo@ejemplo.com",
      isRequiredLabel: "(obligatorio)",
      messageLabel: "Descripción",
      messagePlaceholder: "¿Qué salió mal? ¿Qué esperabas que pasara?",
      successMessageText: "¡Gracias por tu reporte!",
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(AppComponent, appConfig).catch((error) => {
  console.error('Failed to bootstrap UltraStock web app', error);
});
